import { useEffect, useState } from "react";

export enum LazyState {
  Loading = "Loading",
  Loaded = "Loaded",
  Error = "Error",
}

const useLazyLoad = function <T>(fetchData: () => Promise<T>, initialData: T | null = null) {
  const [data, setData] = useState<T | null>(initialData);
  const [state, setState] = useState(LazyState.Loading);
  const [error, setError] = useState<any | null>(null);

  useEffect(() => {
    fetchData()
      .then((result) => {
        setState(LazyState.Loaded);
        setData(result);
      })
      .catch((err) => {
        setState(LazyState.Error);
        setError(err);
      });
  }, [fetchData]);

  return { state, data, error };
};

export default useLazyLoad;
